export const setRECAPTCHA = (recaptcha_public_v2 = '') => ({
  type: 'SET_RECAPTCHA',
  recaptcha_public_v2
})